import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { clearError, selectScimError } from '../reducers/scimManagementSlice';

const ScimErrorBanner = (): JSX.Element | null => {
  const dispatch = useAppDispatch();
  const error = useAppSelector(selectScimError);

  if (error === null) return null;

  return (
    <div
      className="fixed top-4 left-1/2 -translate-x-1/2 z-50 w-full max-w-lg rounded-md bg-red-50 border border-red-200 p-4 flex items-start justify-between gap-3 shadow-md"
      role="alert"
    >
      <p className="text-sm text-red-800">{error}</p>
      <button
        type="button"
        onClick={() => dispatch(clearError())}
        className="text-red-500 hover:text-red-700 shrink-0"
        aria-label="Dismiss error"
      >
        <XMarkIcon className="h-4 w-4" />
      </button>
    </div>
  );
};

export default ScimErrorBanner;
